<template>
  <div class="mt-3">
    <v-form @submit.prevent data-vv-scope="form" lazy-validation>
      <v-row>
        <v-col cols="12" sm="12" md="10">
          <v-text-field
            v-model="keyword"
            placeholder="Cari Akses"
            @keydown.enter="loadAkses"
            outlined
            dense
            :disabled="!peran"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="12" md="2" class="px-0">
          <div class="d-flex justify-space-between">
            <v-btn color="primary" depressed @click="loadAkses"> <v-icon left>mdi-magnify</v-icon>Cari </v-btn>
            <v-btn class="mx-1" color="error" depressed @click="save">
              <v-icon class="mr-2" size="15">mdi-content-save</v-icon>Simpan
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-form>
    <div>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th width="20">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-checkbox v-model="isSelected" :falseValue="0" :trueValue="1">
                      <template v-slot:append>
                        <v-icon v-on="on">mdi-dots-vertical</v-icon>
                      </template>
                    </v-checkbox>
                  </template>
                  <v-list>
                    <v-list-item @click="onAktivasi">
                      <v-list-item-title>Aktifkan Akses</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </th>
              <th class="text-left">
                Label
              </th>
              <th class="text-left">
                Akses
              </th>
              <th class="text-left">
                Status
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-if="permissions.length">
              <tr v-for="(item, i) in permissions" :key="i">
                <td :class="item.id === null ? 'red lighten-5' : ''">
                  <v-checkbox v-model="selected[i]" :falseValue="0" :trueValue="1" />
                </td>
                <td :class="item.id === null ? 'red lighten-5' : ''">
                  {{ item.label || '' }}
                </td>
                <td :class="item.id === null ? 'red lighten-5' : ''">
                  {{ item.name || '' }}
                </td>
                <td :class="item.id === null ? 'red lighten-5' : ''">
                  <v-switch
                    v-model="form[item.id]"
                    :falseValue="0"
                    :trueValue="1"
                    :disabled="item.id === null"
                    inset
                  ></v-switch>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td colspan="4">Belum ada data ditemukan</td>
              </tr>
            </template>
          </tbody>
        </template>
      </v-simple-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormAkses',

  $_veeValidate: {
    validator: 'new',
  },

  data() {
    return {
      isSelected: 0,
      selected: {},
      keyword: null,
      tenant: {},
      peran: [],
      itemTenant: [],
      itemRoles: [],
      akses: [],
      form: {},
    }
  },
  computed: {
    permissions() {
      return (this.akses && this.akses.permissions) || []
    },
  },
  methods: {
    reset() {
      this.$validator.reset()
      this.form = {}
      this.keyword = null
      this.peran = null
      this.akses = []
    },
    tambahAkses(item) {
      if (item) {
        var duplicate = false
        this.akses.permission.forEach((perm) => {
          if ((perm.permission = item.permission)) {
            duplicate = true
            this.$info('Anda tidak dapat memilih akses yang sama')
          }
        })

        if (item && !duplicate)
          var obj = {
            nama: item.nama,
            permission: item.permission,
            value: false,
          }
        this.akses.permission.push(obj)
      }
    },
    hapusAkses(item) {
      this.akses.permission = this.akses.permission.filter((perm) => perm.permission != item.permission)
    },
    save() {
      this.$validator
        .validateAll('form')
        .then((res) => {
          if (!res) return Promise.reject()
          return res
        })
        .then(() => {
          const params = {
            role_id: 1,
            permissions: { ...this.form },
          }
          return this.$store.dispatch('akses/form', params)
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.$info('Simpan Data Berhasil')
          } else {
            this.$error('Simpan Data Gagal')
          }
        })
        .catch((e) => e)
    },

    loadRoles() {
      const params = {
        tenant_id: this.tenant && this.tenant.tenant_id,
      }

      this.$store.dispatch('akses/getRoles', params).then((resp) => {
        this.itemRoles = (resp && resp.data) || []
      })
    },

    loadAkses() {
      const params = {
        role_id: 1,
        keyword: this.keyword || '',
      }

      this.form = {}

      this.$store.dispatch('akses/get', params).then((res) => {
        this.akses = (res && res.data) || []
        const { role_permissions, permissions } = res && res.data

        permissions.forEach((key, index) => {
          const find = role_permissions.find((s) => s.permission_id === key.id) || {}
          this.$set(this.form, key.id, Object.keys(find).length ? Number(find['is_aktif']) : 0)
          this.$set(this.selected, index, 0)
        })
      })
    },

    onAktivasi() {
      this.$confirm('Aktifkan hak akses', {}, 'Apakah Anda yakin ingin meng-aktifkan akses yang Anda pilih? ? ').then(
        () => {
          const selected =
            Object.keys(this.selected)
              .map((key) => {
                return {
                  id: key,
                  value: this.selected[key],
                }
              })
              .filter((s) => s.value === 1) || []

          let permissions = selected.map((key) => {
            return this.permissions[Number(key.id)]['name']
          })

          this.$store.dispatch('akses/create', { permissions }).then((res) => {
            if (res.data.code === 200) {
              this.$success('Aksi berhasil dijalankan')
              this.loadAkses()
            } else {
              this.$error('Simpan Data Gagal')
            }
          })
        }
      )
    },
  },

  watch: {
    tenant: {
      handler(s) {
        if (s.tenant_id) {
          this.loadRoles()
        }
      },
      deep: true,
    },
    isSelected(s) {
      const selected = { ...this.selected }
      Object.keys(selected).forEach((key) => {
        this.$set(this.selected, key, s)
      })
    },
  },
}
</script>
